/*** nozzleList.js ***/
/* Project: Pump Panel Simulator
   Descript: Training tool to assist in learing 
   Created: Kendra Wainscott  2022

   list of all nozzels and their image
*/
export const allNozzles = {
  chief_50_250: {
    name: "Cheif 50/250",
    src: require("./chief_50_250.jpg"),
  },
  smoothBore_15_16: {
    name: 'Smooth Bore 15/16"',
    src: require("./smoothBore_15_16ths.jpg"),
  },
  TSM_3F: {
    name: "TSM 3F",
    src: require("./TSM_3F.jpg"),
  },
  TSM_20F_autoFog: {
    name: "TSM 20F Auto Fog",
    src: require("./TSM_20F_autoFog.jpg"),
  },
};
